module.exports = __webpack_public_path__ + "static/media/transactions.82aabd3b.svg";